// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1eGDb","label":"Completed_label__31MGq"};